<template>
    <div class="file-manager">
        <Button type="primary" @click="addMaterial(1)">上传</Button>
        <Button type="success" @click="addMaterial(2)">新建文件夹</Button>
        <!-- 根表格（显示表头） -->
        <Table :columns="columns" :data="fileList" border></Table>
        <page-component class="page" :page-size="page.size" :total-num="page.total" :page-num="page.current"
                        v-on:changePage="changePage" v-on:changePageSize="changePageSize"
                        v-on:clickPage="changePage"></page-component>
    </div>
</template>

<script>
import pageComponent from "../common/page.vue";
import http from "../../libs/http.js";

export default {
    components: {pageComponent},
    data() {
        return {
            groupId: this.$route.query.groupId,
            loading: false,
            page: {
                total: 1,
                current: 1,
                size: 10
            },
            fileList: [],
            columns: [
                {
                    type: "expand",
                    width: 50,
                    render: (h, params) => this.renderExpandContent(h, params.row)
                },
                {
                    title: "名称",
                    key: "name",
                    render: (h, params) => {
                        let iconMap = {
                            folder: "ios-folder",
                            pdf: "ios-document",
                            zip: "ios-zip",
                            default: "ios-document"
                        };
                        let icon = iconMap[params.row.type] || iconMap.default;

                        return h("div", [
                            h("Icon", {
                                props: { type: icon },
                                style: { marginRight: "8px", color: params.row.type === "folder" ? "#2d8cf0" : "#52c41a" }
                            }),
                            h("span", params.row.name)
                        ]);
                    }
                },
                {
                    title: "文件类型",
                    key: "type"
                },
                {
                    title: "修改时间",
                    key: "createTime"
                },
            ]
        };
    },
    mounted() {
        this.getGroupMaterial(this.name,this.page);
    },
    methods: {
        renderExpandContent(h, row) {
            if (row.type !== "folder" || !row.children || row.children.length === 0) {
                return h("div", { style: { padding: "8px" } }, "无内容");
            }

            // 递归创建子表格（核心修改：添加 showHeader: false 隐藏表头）
            return h("Table", {
                props: {
                    columns: this.columns,
                    data: row.children,
                    border: true,
                    size: "small",
                    showHeader: false // 子表格不显示表头
                },
                style: { margin: "8px 0 8px 10px" }
            });
        },
        //当前页数
        changePage(current) {
            this.page.current = current;
            this.getGroupMaterial(this.name,this.page);
        },
        //当前每页显示的条数
        changePageSize(data) {
            this.page.size = data;
            this.getGroupMaterial(this.name,this.page);
        },
        //获取课程列表
        getGroupMaterial(name,page) {
            let that = this;
            that.loading = true;
            const { current, size } = page
            http.get("/madyGroupMaterial/list", {
                name,
                current, size
            }).then(res => {
                that.loading = false;
                if (res) {
                    that.fileList = res.records;
                    that.page.current = res.current;
                    that.page.total = res.total;
                }
            });
        },
        //上传
        addMaterial(operType) {
            this.$router.push({
                path: "addMaterial",
                query: { operType: operType, groupId: this.groupId }
            });
        },
    }
};
</script>

<style scoped>
.file-manager {
    padding: 10px;
    background-color: #f5f7fa;
}
.file-manager ::v-deep td.ivu-table-expanded-cell {
    padding: 1px 1px;
    background: #f5f7fa;
    border-top: 1px solid #e9e9e9;
}

/* 可选：隐藏子表格的展开列宽度（更紧凑） */
.file-manager ::v-deep .ivu-table-small .ivu-table-expand-icon-cell {
    width: 30px !important;
}
</style>
